import React from "react";
import "./header.css";
import Aboutme from "./aboutme";

const Header = () => {
  return (
    <div className="header">
      <Aboutme />
    </div>
  );
};

export default Header;
